<script>
  import { createEventDispatcher } from "svelte";

  export let videoAccount = "";
  export let videoId = "";
  export let exitButton = "";

  const dispatch = createEventDispatcher();

  function exit() {
    dispatch("close-video", false);
    log2('media', 'video-closed');
    loggin('media', 'video-closed');
  }
</script>

<style type="text/scss">

  .video-holder {
    width: 100%;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    z-index: 30;
    display: flex;
    justify-content: center;
    background: black;
    
    .video {
      align-self: center;
      width: 75%;

      video {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        object-fit: contain;
        object-position: center;
      }
    }
    .close-container {
      width: 75%;
      position: absolute;
      z-index: 40;
      top: 0;
      right: 0;
    }
    .exit {
      float: right;
      width: 2.5rem;
      margin: 3rem 2.5rem;
      cursor: pointer;
    }

    .close-video {
      z-index: 10;
    }
  }
</style>

<div class="video-holder">
  <div class="video">
    <div class="close-container">
      <div class="exit close-video" on:click={exit}>
        <img class="img" src={exitButton} alt="exit" />
      </div>
    </div>
    <video src={videoId} autoplay controls="true"></video>
  </div>
</div>
